export const megaphone = () => (
  <path
    d="M18.93 5a2 2 0 011.73 2.996M7.403 17.47l-.288.103a3.595 3.595 0 01-3.537-6.125l6.239-5.292 1.964-4.598 8 13.857-4.964-.599-4.543 1.627m-2.856 1.023l1.86 3.243a1.498 1.498 0 102.597-1.494L6.136 9.277"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
